<template>
    <div>
        <v-autocomplete
                hide-details
                v-model="pickedIds"
                :items="items"
                item-value="id"
                item-text="name"
                @change="onChange"
                multiple
                outlined
        >
            <template v-slot:prepend-item>
                <v-list-item
                        ripple
                        @click="toggle"
                >
                    <v-list-item-action>
                        <v-checkbox
                                hide-details
                                class="mt-0 checkbox-all"
                                :indeterminate="isPickedSome"
                                v-model="isPickedAll"
                                @click.stop="toggle"
                        ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Toutes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
            </template>
        </v-autocomplete>
        <v-flex xs12 sm12 md12 v-if="pickedItems.length > 0">
            <v-flex xs12>
                <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
                    <template v-for="(item, index) in pickedItems">
                        <v-chip
                                close-icon="$close"
                                close
                                outlined
                                label
                                color="#202020"
                                :key="item.id"
                                class="mr-2 my-2"
                                @click:close="unpick(index)"
                        >
                            <span class="body-2">{{ item.name }}</span>
                        </v-chip>
                    </template>
                </v-card>
            </v-flex>
        </v-flex>
    </div>
</template>

<script>
  export default {
    name: "MultipleGroupPickerInput",
    props: {
      value: { },
      items: { type: Array, default: [] }
    },
    data() {
      return {
        pickedIds: []
      }
    },
    computed: {
      isPickedAll() {
        return this.pickedIds.length === this.items.length;
      },
      isPickedSome() {
        return this.pickedIds.length > 0 && !this.isPickedAll;
      },
      pickedItems() {
        const _this = this;

        return _this.pickedIds.map((id) => {
          return _this.items.find((item) => {
            return item.id === id;
          })
        });
      },
    },
    methods: {
      toggle () {
        const _this = this;

        this.$nextTick(() => {
          if (this.isPickedAll) {
            _this.pickedIds = []
          } else {
            _this.pickedIds = _this.items.map((item) => item.id);
          }

          _this.$emit('input', _this.pickedIds);
        })
      },
      unpick(index) {
        this.pickedIds.splice(index, 1);

        this.$emit('input', this.pickedIds);
      },
      onChange() {
        this.$emit('input', this.pickedIds);
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (!Array.isArray(value)) {
            return;
          }

          this.pickedIds = value;
        }
      }
    }
  }
</script>

<style scoped>

</style>
